<ng-template #inline>
	<ng-container *transloco="let t;read:'radioList'">
		<div class="checkbox-list-container"
			 [class.input-container-pristine]="control.pristine && !hasValue || control.valid && !hasValue"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="!control.pristine && hasValue">
			<h4 *transloco="let t; read: 'journal'">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</h4>
			<div class="d-flex flex-wrap">
				<div class="c-mb-1" *ngFor="let item of options; let i = index">
					<form-checkbox
						class="c-mr-1"
						[label]="item"
						[control]="formArray.at(i)"
						[id]="idArr[i]">
					</form-checkbox>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="!control.pristine && control.errors">
		<ng-container *ngTemplateOutlet="errors"></ng-container>
	</ng-container>
</ng-template>

<ng-template #notInline>
	<div class="checkbox-list-container row align-items-center m-0"
		 [class.input-container-pristine]="control.pristine && !hasValue || control.valid && !hasValue"
		 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
		 [class.input-container-valid]="!control.pristine && hasValue"
		 *transloco="let t;read:'checkboxList'">
		<div class="col-3" *ngIf="template !== ControlTemplate.vertical">
			<div class="row m-0 p-0 h-100 align-content-center">
				<h4 class="m-0"
					*transloco="let t; read: 'journal'">{{label}}
					<ng-container *ngFor="let warning of warnings | keyvalue">
						<span *ngIf="warning.value"
							  [ngbTooltip]="t('warnings.'+warning.key)"
							  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
				</h4>
			</div>
		</div>
		<div class="input-group shadow-none p-0"
			 [ngClass]="{
			     'col-9': template !== ControlTemplate.vertical,
			     'col-12': template === ControlTemplate.vertical
			     }">
			<div class="col-12 p-0" *ngIf="template === ControlTemplate.vertical">
				<h4 *transloco="let t; read: 'journal'">{{label}}
					<ng-container *ngFor="let warning of warnings | keyvalue">
						<span *ngIf="warning.value"
							  [ngbTooltip]="t('warnings.'+warning.key)"
							  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
				</h4>
			</div>
			<div *ngIf="formArray"
				 class="list-group list-group-flush"
				[class.variant-vertical]="variant === ControlTemplate.vertical"
				[class.variant-horizontal]="variant === ControlTemplate.horizontal">
				<div class="list-group-element" *ngFor="let item of options; let i = index">
					<form-checkbox
						[label]="item"
						[control]="formArray.at(i)"
						[id]="idArr[i]">
					</form-checkbox>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<div class="control-errors-wrapper">
		<div class="control-errors col-12 pl-0" *ngFor="let error of control.errors | keyvalue">
			<span class="error">{{error.value}}</span>
		</div>
	</div>
</ng-template>

<ng-container>
	<div [ngSwitch]="template" class="form-control-container">
		<ng-container *ngSwitchCase="ControlTemplate.horizontal">
			<ng-container *ngTemplateOutlet="notInline"></ng-container>
			<ng-container *ngIf="!control.pristine && control.errors">
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.vertical">
			<ng-container *ngTemplateOutlet="notInline"></ng-container>
			<ng-container *ngIf="!control.pristine && control.errors">
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</ng-container>
		<ng-container *ngSwitchCase="ControlTemplate.inline">
			<ng-container *ngTemplateOutlet="inline"></ng-container>
		</ng-container>
	</div>
</ng-container>
